/**
 * A collection of well known error messages in the application.
 */
const ERROR_MESSAGES = {
  DEFAULT: 'Oops! There was a system error. Don’t worry, our development team have been notified of this issue and they are working on it.  Please try again in a few minutes.',
};

export default ERROR_MESSAGES;
